up.compiler('[auto-close-bookmarklet]', function(fragment) {
  const closeButton = up.element.get(fragment, '.auto-close-bookmarklet--close')
  up.on(closeButton, 'click', () => window.close())
  window.close()
})
